import { useEffect, useState } from "react";
import api from "@/lib/api";

const EMPTY = {
  stage: [], source: [], sub_source: [], status: [], sub_status: [], category: [], concern: [], service: [], location: [],
  followup_type: [], followup_priority: [], followup_outcome: [],
};

/**
 * Fetches active master-data options for lead fields and returns them in the
 * shapes the lead pages expect.
 *
 * Model note: `stage` is the temperature (hot/warm/cold); `status` is the
 * pipeline (New → Converted) and carries the badge color + rotting timers.
 */
export function useMasterData() {
  const [data, setData] = useState(EMPTY);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/master-data")
      .then((r) => setData({ ...EMPTY, ...r.data }))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return {
    loading,
    stages: data.stage.map((s) => ({ value: s.value, label: s.label, color: s.color })),
    sources: data.source.map((s) => s.value),
    subSources: data.sub_source.map((s) => ({ value: s.value, label: s.label || s.value, parent: s.parent })),
    statuses: data.status.map((s) => ({ value: s.value, label: s.label, color: s.color, rotting_days: s.rotting_days })),
    subStatuses: data.sub_status.map((s) => s.value),
    categories: data.category.map((s) => s.value),
    concerns: data.concern.map((s) => s.value),
    services: data.service.map((s) => s.value),
    locations: data.location.map((s) => s.value),
    followupTypes: data.followup_type.map((s) => ({ value: s.value, label: s.label, color: s.color })),
    followupPriorities: data.followup_priority.map((s) => ({ value: s.value, label: s.label, color: s.color })),
    followupOutcomes: data.followup_outcome.map((s) => ({ value: s.value, label: s.label, color: s.color })),
  };
}
